export interface UploadOrderId {__uploadOrderId: number}

export default class UploadOrder {
  id!: UploadOrderId;
  pin = '';
}
